import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import ErrorBoundary from "./ErrorBoundary.jsx";
import CookieBanner from "./CookieBanner.jsx";
import { I18nProvider } from "./i18n/I18nContext.jsx";
import "./styles.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <App />
        <CookieBanner />
      </I18nProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
